import { useInitializationDataContext } from '../context/data-context';
import { useQueryParams } from './use-query-params';

/**
 *  Hook that returns a boolean to check if the project is 1:Many
 * Conditions for 1:M
 * - qty query parameter should be defined
 *
 * @returns true if the project is 1:Many
 */
export const useIsOneToMany = () => {
  const queryParams = useQueryParams();
  const quantity = Number(queryParams.get('qty'));
  const {
    initializedDataState: { data: initializedData, isUK },
  } = useInitializationDataContext();
  const isFlatCard = initializedData?.variables?.template_data.Faces.length === 2;
  return (!isUK && quantity >= 1) || ((isFlatCard || !!isUK) && quantity >= 1);
};
